import { render, staticRenderFns } from "./LayerLegend.vue?vue&type=template&id=21ba2d3e&scoped=true"
import script from "./LayerLegend.vue?vue&type=script&lang=ts"
export * from "./LayerLegend.vue?vue&type=script&lang=ts"
import style0 from "./LayerLegend.vue?vue&type=style&index=0&id=21ba2d3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ba2d3e",
  null
  
)

export default component.exports